
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/frames/base-drop",
      function () {
        return require("private-next-pages/frames/base-drop.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/frames/base-drop"])
      });
    }
  